import { styled } from '@mui/material/styles';
import MuiGrid from '@mui/material/Grid';
import MuiContainer from '@mui/material/Container';

export const Container = styled(MuiContainer)(({ theme }) => ({
  padding: theme.spacing(20, 0),
  marginTop: theme.spacing(16),
  marginBottom: theme.spacing(16),
  backgroundColor: theme.palette.blue10.main,
}));

export const Grid = styled(MuiGrid)(({ theme }) => ({
  border: `1px solid ${theme.palette.black40.main}`,
  borderRadius: 8,
}));

export const Content = styled(MuiContainer)(({ theme }) => ({
  padding: theme.spacing(0, 6),
}));
